import { Button, Heading, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, ModalProps, Text, useDisclosure } from '@chakra-ui/react'
import React from 'react'



interface IProps extends Omit<ModalProps, "children"> {
  onOk?: () => void;
}

export default function ConfirmModal({isOpen, onOk, onClose, ...props}: IProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false} {...props}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody py="20px" alignItems="center" display="flex">
              <Heading as="h6" fontSize="16px">
                Bạn có chắc muốn thực hiện thao tác này ?
              </Heading>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onOk} >
              Đồng ý
            </Button>
            <Button onClick={onClose}>
              Bỏ qua
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}
